import React, { useEffect, useState } from "react";
import axios from "axios";
import { Notify } from "notiflix";
import MyIntrest from "./small-components/myIntrest";
import RecivedIntrest from "./small-components/recivedProfile";

const IntrestProfileSection = () => {
    const [showAll, setShowAll] = useState(false);
      const [activeTab, setActiveTab] = useState('myintrest');
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [Reload, setReload] = useState(false);

    const visibleProfiles = showAll ? profiles : profiles.slice(0, 4);

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        setLoading(true); // start loading
        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/my-intrested-profile-list",
                { headers }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setProfiles(response.data.data);
                } else {
                    Notify.failure(response.data.message);
                }
            })
            .catch(() => {
                Notify.failure("Failed to fetch interested profiles");
            })
            .finally(() => {
                setLoading(false); // stop loading
            });
    }, [Reload]);
    const HandleTab = (tab) => {
        if (tab === "receviedintrest") {
            setProfiles("");
        }
        setActiveTab(tab);
    }

    return (
        <>
            <div className="search-wrapper px-3">
                <div className="search-container">
                    <div className="search-tabs">
                        <button
                            className={`tab-btn ${activeTab === 'myintrest' ? 'active' : ''}`}
                            onClick={() => HandleTab('myintrest')}
                        >
                           My Intrest
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'receviedintrest' ? 'active' : ''}`}
                            onClick={() => HandleTab('receviedintrest')}
                        >
                           Received Intrest
                        </button>
                    </div>

                    {activeTab === 'myintrest' && (
                        <>
                          <MyIntrest />
                        </>
                    )}



                    {activeTab === 'receviedintrest' && (
                        <>
                            <RecivedIntrest/>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default IntrestProfileSection;
